'use strict';

var React = require('react');
var CardContainer = require('@swiggy-private/dls-web-core/dist/components/CardContainer');
var Button = require('@swiggy-private/dls-web-core/dist/components/Button');
var styled = require('styled-components');
var Text = require('@swiggy-private/dls-web-core/dist/components/Text');
var HalfCard = require('@swiggy-private/dls-web-core/dist/components/HalfCard');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);
var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

const ADD_CUSTOMIZED_TITLE = "Repeat previous customisation?";
const CTA_TEXT = {
    I_LL_CHOOSE: "I’ll choose",
    REPEAT: "Repeat",
};

const Container = styled__default.default.div(({ theme }) => ({
    backgroundColor: theme.colors[theme.colorMode].background_Secondary,
}));
const ContentContainer = styled__default.default.div(({ theme }) => ({
    padding: `${theme.spacing.xxLarge} ${theme.spacing.medium}`,
    backgroundColor: theme.colors[theme.colorMode].background_Secondary,
}));
styled__default.default(CardContainer.CardContainer)(({ theme }) => ({
    padding: `${theme.spacing.large} ${theme.spacing.medium}`,
    marginTop: theme.spacing.medium,
}));
const ButtonContainer = styled__default.default.div(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    background: theme.colors[theme.colorMode].background_Primary,
    padding: theme.spacing.medium,
    justifyContent: "space-between",
    boxShadow: "0px -3px 20px 0px rgba(0, 0, 0, 0.08)",
}));
const StyledButton = styled__default.default.button(({ theme }) => ({
    width: "48%",
    height: "44px",
    borderRadius: theme.spacing.small,
    border: `1px solid ${theme.colors[theme.colorMode].positive}`,
    textAlign: "center",
}));
const RepeatButton = styled__default.default(Button.Button) `
    text-align: center;
`;
const RepeatButtonContainer = styled__default.default.div `
    width: 48%;
`;

const CustomizedItemMessage = ({ confirm, reject }) => {
    return (React__default.default.createElement(Container, { role: "dialog", "aria-modal": "true" },
        React__default.default.createElement(ContentContainer, null,
            React__default.default.createElement(Text.Text, { variant: "V2.heading2.neutral.black", color: "text_High_Emphasis" }, ADD_CUSTOMIZED_TITLE)),
        React__default.default.createElement(ButtonContainer, null,
            React__default.default.createElement(StyledButton, { onClick: reject },
                React__default.default.createElement(Text.Text, { color: "positive", variant: "V2.body1.neutral.bold" }, CTA_TEXT.I_LL_CHOOSE)),
            React__default.default.createElement(RepeatButtonContainer, null,
                React__default.default.createElement(RepeatButton, { onClick: confirm, variant: "positive" }, CTA_TEXT.REPEAT)))));
};
var CustomizedItemMessage$1 = React__default.default.memo(CustomizedItemMessage);

const CustomizedItemPrompt = (props) => {
    return (React__default.default.createElement(React__default.default.Fragment, null,
        React__default.default.createElement(HalfCard.HalfCard, { isOpen: props.showPrompt, hasCustomPadding: true },
            React__default.default.createElement(CustomizedItemMessage$1, { confirm: props.confirm, reject: props.reject }))));
};
var CustomisePrompt = React__default.default.memo(CustomizedItemPrompt);

exports.CustomisePrompt = CustomisePrompt;
//# sourceMappingURL=CustomisePrompt-BEky4xtR.js.map
